// src/store/auth.module.js
import {defineStore} from 'pinia';
import AuthService from '@/services/auth.service';
import { usePermissionsStore } from './permissions';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: true, user } : { loggedIn: false, user: null };

export const useAuthStore = defineStore('auth', {
    state: () => ({
        status: initialState,
    }),
    actions: {
        async login(user) {
            try {
                const loggedInUser = await AuthService.login(user);
                this.loginSuccess(loggedInUser);
                
                // 로그인 성공 후 권한 정보 로드
                const permissionsStore = usePermissionsStore();
                await permissionsStore.fetchUserPermissions();
                
                return Promise.resolve(loggedInUser);
            } catch (error) {
                this.loginFailure();
                return Promise.reject(error);
            }
        },
        logout() {
            AuthService.logout();
            // 로그아웃 시 권한 정보도 초기화
            const permissionsStore = usePermissionsStore();
            permissionsStore.clearPermissions();
            this.logoutSuccess();
        },
        loginSuccess(user) {
            this.status.loggedIn = true;
            this.status.user = user;
        },
        loginFailure() {
            this.status.loggedIn = false;
            this.status.user = null;
        },
        logoutSuccess() {
            this.status.loggedIn = false;
            this.status.user = null;
        },
    },
    getters: {
        isAuthenticated: (state) => state.status.loggedIn,
    },
});
